import React from 'react';

export default function Activity() {
	return (
		<div className="main">
			<p style={{fontSize:"20px", color:"var(--text-color)"}}>ACTIVITY</p>
		</div>
	);
}